import React, { useEffect, useInsertionEffect, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";


import { useDispatch, useSelector } from "react-redux";

import { Ismobiles, getBase64, getMemberinfo, hpHypen, numFormat } from "../utils/utils";
import { close, loadingflas, open } from '../redux/popupSlice';

import * as APIS from "../utils/service";
import consts from '../libs/consts';
import userEvent from '@testing-library/user-event';


export default function ProfilesLine(props) {

    const { 
        profileimgs=false,
        margintClass='',
        mypages=false,
        memberinfosData=null,
        companyinfos=null,
        Trophyinfo=true,
        profilesimgButtons=true,
        favremove=false,
        blackremove=false,
        favblackData={}
    } = props;


    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [memberinfos, setmemberinfos] = useState(''); 
    const [favblackDatas, setfavblackDatas] = useState(favblackData); 
    const selectFile = useRef(null);

    const [bedge, setbedge] = useState(''); 
    const [bedgetropy, setbedgetropy] = useState(''); 
    
    // useEffect(() => {
    //     //getMemberinfo(setmemberinfos);
    // }, []);
    useEffect(() => {
        if(memberinfosData !== null){
            setmemberinfos(memberinfosData);
        }
    }, [memberinfosData]);


    useEffect(() => {
        if(memberinfos){
            let bedge = memberinfos?.badges?.filter(item => item.type !== 1);
            setbedge(bedge);
            console.log(memberinfos?.badges?.filter(item => item.type === 1));
            setbedgetropy(memberinfos?.badges?.filter(item => item.type === 1)[0]);
        }
    }, [memberinfos]);
    
    return (
        <>
        {memberinfos &&
            <div className={`storedamdang ${margintClass}`} style={{ position: 'relative' }}>
                <div
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 12, padding: 5}}
                >
                    <div>공동중개 평가점수 : 상위 {memberinfos?.mediation_count*1 > 4 ? memberinfos?.score_per !== null ? memberinfos?.score_per : '-' : '-' }%</div>
                    <div style={{ width: 1, height: 12, backgroundColor: '#CCCCCC'}}></div>
                    <div
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10}}
                    >
                        <span>획득 칭호 : </span>
                        <div className='Trophystickarea' style={{ marginTop: 0 }}>
                            {bedge?.length > 0 && bedge?.map((x, i) => {
                                if(i > 2) return;
                                return (
                                    <>
                                    <div key={`bedge${i}`} className="trophysticker style4">{x?.title}</div>
                                    </>
                                );
                            })}
                            {bedge?.length > 3 && '...'}
                        </div>
                    </div>
                </div>
            </div>
        }
        </>
    )    
}